export default {
    init(successFun) {

        let input = document.createElement("input");
        input.type = "file";
        input.accept = "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        input.click();

        //添加事件
        input.addEventListener("change", listener => {
            let files = listener.target.files;
            let file = files.length > 1 ? files[0] : files[0]

            successFun(file)
        })


    }
}